import { EVENT } from '..';
import { playerBus } from '@videotools/js/events';
import { createHeartbeat } from '@shared/js/heartbeat';
import storage from '@shared/js/storage';

export const heartbeat = createHeartbeat();

const handleEventChange = (eventId) => heartbeat.setEventId(eventId);
const handleMediaChange = () => heartbeat.resetAndStart();
const handlePlay = () => heartbeat.start();
const handlePause = () => heartbeat.pause();

const register = (bus) => {
	bus.subscribe(EVENT.EVENT_UPDATE, handleEventChange);
	bus.subscribe(EVENT.PLAYER.ON.MEDIA_CHANGE, handleMediaChange);
	bus.subscribe(EVENT.PLAYER.ON.PLAY, handlePlay);
	bus.subscribe(EVENT.PLAYER.ON.PAUSE, handlePause);

	heartbeat.setParallelViewHandler((data) => {
		bus.publish(EVENT.PLAYER.REQUEST.PAUSE);
		bus.publish(EVENT.PARALLEL_VIEW_DETECTED, data);
	});

	heartbeat.setPlayerBus(playerBus);
	heartbeat.setViewerId(storage.viewerId);
};
const unregister = (bus) => {
	bus.unsubscribe(EVENT.EVENT_UPDATE, handleEventChange);
	bus.unsubscribe(EVENT.PLAYER.ON.MEDIA_CHANGE, handleMediaChange);
	bus.unsubscribe(EVENT.PLAYER.ON.PLAY, handlePlay);
	bus.unsubscribe(EVENT.PLAYER.ON.PAUSE, handlePause);
};

export const setEventId = heartbeat.setEventId;
export const setPayload = heartbeat.setPayload;
export { register, unregister };
